import { MERCHANT } from "constants/action-types";
import { IGridItem } from "constants/product-collection";
import { FluxStandardAction as Action } from "flux-standard-action";

export type GetMerchantDefaultItemRequestAction = Action<
    {
        merchantId: string;
    },
    {}
>;
export const getMerchantDefaultItemRequest = (merchantId: string): GetMerchantDefaultItemRequestAction => ({
    meta: {},
    payload: { merchantId },
    type: MERCHANT.DEFAULT_ITEM.GET.REQUEST,
});

export type GetMerchantDefaultItemCompleteAction = Action<IGridItem | Error, {}>;
export const getMerchantDefaultItemComplete = (payload: IGridItem | Error): GetMerchantDefaultItemCompleteAction => ({
    meta: {},
    payload,
    error: payload instanceof Error,
    type: MERCHANT.DEFAULT_ITEM.GET.COMPLETE,
});

export type CreateMerchantDefaultItemRequestAction = Action<
    {
        merchantId: string;
        defaultItem: IGridItem;
    },
    {}
>;
export const createMerchantDefaultItemRequest = (
    merchantId: string,
    defaultItem: IGridItem
): CreateMerchantDefaultItemRequestAction => ({
    meta: {},
    payload: { merchantId, defaultItem },
    type: MERCHANT.DEFAULT_ITEM.CREATE.REQUEST,
});

export type CreateMerchantDefaultItemCompleteAction = Action<IGridItem | Error, {}>;
export const createMerchantDefaultItemComplete = (
    payload: IGridItem | Error
): CreateMerchantDefaultItemCompleteAction => ({
    meta: {},
    payload,
    error: payload instanceof Error,
    type: MERCHANT.DEFAULT_ITEM.CREATE.COMPLETE,
});

export type UpdateMerchantDefaultItemRequestAction = Action<
    {
        merchantId: string;
        defaultItem: IGridItem;
    },
    {}
>;
export const updateMerchantDefaultItemRequest = (
    merchantId: string,
    defaultItem: IGridItem
): UpdateMerchantDefaultItemRequestAction => ({
    meta: {},
    payload: { merchantId, defaultItem },
    type: MERCHANT.DEFAULT_ITEM.UPDATE.REQUEST,
});

export type UpdateMerchantDefaultItemCompleteAction = Action<IGridItem | Error, {}>;
export const updateMerchantDefaultItemComplete = (
    payload: IGridItem | Error
): UpdateMerchantDefaultItemCompleteAction => ({
    meta: {},
    payload,
    error: payload instanceof Error,
    type: MERCHANT.DEFAULT_ITEM.UPDATE.COMPLETE,
});
